import { CompanySizeOption } from 'signup-constants/signupData/CompanySizeOption';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { NextStepManager } from '../../flow-management/NextStepManager';
import { Data } from '../../signup-data/DATA';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { getCurrentStep } from '../../store/flow/selectors';
import { bulkSetSignupDataAndSetValidAndCompleted } from '../../store/signup-data/action-creators';
import { getSignupDataValue } from '../../store/signup-data/selectors';
import { Step } from '../../views/Step';
import { ManagementLevel } from 'signup-constants/signupData/ManagementLevel';
export const BranchACQ142CompanySize = {
  name: 'BranchACQ142CompanySize',
  stateCheck: state => {
    return getSignupDataValue(state, Data.CompanySize) === CompanySizeOption.One && getCurrentStep(state) === Step.CompanySize && getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0142, [ExperimentParameterGroup.Variant_A, ExperimentParameterGroup.Variant_B]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    dispatch(bulkSetSignupDataAndSetValidAndCompleted({
      [Data.ManagementLevel]: ManagementLevel.Owner
    }));
    const nextSteps = NextStepManager.removeSteps(Step.ManagementLevel)(flow);
    return nextSteps;
  },
  processed: false,
  processedOnStep: Step.CompanySize,
  afterData: null,
  afterStep: null
};